import { IRecommendsItem } from '@/shared/FeaturedActivities/ui/featuredActivitiesPreview/FeaturedActivitiesPreview.types';
import { NewFeaturedActivities } from '@/shared/FeaturedActivities/ui/NewFeaturedActivities';
import Head from 'next/head';

export type TRecommendsPageProps = {
    recommendedTrips?: IRecommendsItem[];
    placeholders: {
        [key: string]: string;
    };
};

export const RecommendsPage = ({ recommendedTrips, placeholders }: TRecommendsPageProps) => {
    return (
        <>
            <Head>
                <meta name="robots" content="noindex" />
            </Head>
            <NewFeaturedActivities
                defaultActivities={recommendedTrips || []}
                item_list_id=""
                item_list_name=""
                placeholders={placeholders}
                noPaddingContainer
                isWidget
            />
        </>
    );
};
